import { useSgwtWidgets } from '@sgwt/sgwt-widgets-react';
import { FormattedMessage } from 'react-intl';

import { useForwardAccumulatorTileId } from '@/App/tiles/ForwardAccumulator/ProductProvider.tsx';
import { selectDisplayMode, selectForwardAccumulatorCustomFields } from '@/store/forwardAccumulator/selectors.ts';
import { forwardAccumulatorSlice } from '@/store/forwardAccumulator/slice.ts';
import type { DisplayMode } from '@/store/forwardAccumulator/state';
import { useAppDispatch, useAppSelector } from '@/store/hooks.ts';
import { selectActiveTabZoomedTileId, setZoomedTileIdForActiveTab } from '@/store/tabs/slice.ts';

const RightColumnHeader = () => {
  const dispatch = useAppDispatch();
  const { sgwtWebAnalytics } = useSgwtWidgets();

  const tileId = useForwardAccumulatorTileId();
  const displayMode = useAppSelector((state) => selectDisplayMode(state, tileId));

  const customFields = useAppSelector((state) => selectForwardAccumulatorCustomFields(state, tileId));
  const isCustom = customFields && customFields.length > 0;
  const isZoomed = useAppSelector(selectActiveTabZoomedTileId) === tileId;

  const setDisplayMode = (mode: DisplayMode) => {
    sgwtWebAnalytics?.trackEvent('Forward Accumulator', 'Display mode changed', mode);
    dispatch(forwardAccumulatorSlice.actions.forwardAccumulatorSetDisplayMode({ tileId, displayMode: mode }));
  };

  function zoom() {
    sgwtWebAnalytics?.trackEvent('Forward Accumulator', 'Zoom button clicked', tileId);
    dispatch(setZoomedTileIdForActiveTab({ tileId }));
  }

  return (
    <ul className="nav nav-compact-pills">
      <li className="nav-item me-auto">
        <span className="nav-link px-16px py-8px" data-nodrag="true" data-e2e="type-text">
          Standard
        </span>
      </li>
      <li className="d-flex align-items-center nav-item">
        <button
          type="button"
          className={`nav-link ${displayMode === 'Pricer' ? 'active' : ''}`}
          tabIndex={-1}
          data-nodrag="true"
          data-e2e="pricer-mode"
          onClick={() => setDisplayMode('Pricer')}
        >
          Pricer
        </button>
      </li>
      <li className="d-flex align-items-center gap-4px nav-item">
        <button
          type="button"
          className={`nav-link ${displayMode === 'Scheduler' ? 'active' : ''}`}
          tabIndex={-1}
          data-nodrag="true"
          data-e2e="scheduler-mode"
          onClick={() => setDisplayMode('Scheduler')}
        >
          Scheduler
        </button>
        {isCustom && (
          <span className="text-info">
            <FormattedMessage id="forwardAccumulator.customFields.edited" />
          </span>
        )}
      </li>
      {!isZoomed && (
        <li className="nav-item pe-2">
          <button
            type="button"
            className="btn btn-flat-secondary btn-icon h-100 text-nowrap"
            onClick={zoom}
            data-e2e="zoom-btn"
          >
            <i className="icon">zoom_out_map</i>
          </button>
        </li>
      )}
    </ul>
  );
};

export default RightColumnHeader;
